// extracted by mini-css-extract-plugin
module.exports = {"PeopleCards":"PeopleCards_PeopleCards__5590r"};